module.exports = __webpack_public_path__ + "img/border_rightTriangle.dc27ab98.svg";